import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const labelMap = {
  "Candidate - Created": "Candidate",
  "Telephonic Screening - Completed": "Telephonic Screening",
  "Video Interview - Completed": "Video Interviews",
  "AI Assessments - Completed": "AI Assessments",
};

const colorMap = {
  "Candidate - Created": "#f9a825",
  "Telephonic Screening - Completed": "#0048B7",
  "Video Interview - Completed": "#FF1C58",
  "AI Assessments - Completed": "#00DDFF",
};

const getShortLabel = (label) => labelMap[label] || label;
const getColorByLabel = (label) => colorMap[label] || '#aaa';

const PerformanceLineChart = ({ chartData }) => {
  const allowedLabels = Object.keys(labelMap);

  const hasData = chartData?.series?.length > 0;
  const filteredSeries = hasData
    ? chartData.series.filter((item) => allowedLabels.includes(item.label))
    : [];

  const hasFilteredData = filteredSeries.length > 0;

  const placeholderSeries = allowedLabels.map(label => ({
    name: getShortLabel(label),
    data: (chartData?.labels || []).map(() => null), // null keeps grid without showing lines
    color: getColorByLabel(label),
    marker: { enabled: false }
  }));

  const options = {
    chart: {
      type: "line",
      height: 450,
      spacingTop: 30,
    },
    title: { text: null },
    xAxis: {
      categories: chartData?.labels || [],
      labels: { rotation: 45 },
    },
    yAxis: {
      title: { text: null },
      gridLineDashStyle: "Dash",
      min: (!hasData || !hasFilteredData) ? 0 : null,
      max: (!hasData || !hasFilteredData) ? 100 : null,
      tickInterval: (!hasData || !hasFilteredData) ? 20 : null
    },
    legend: {
      enabled: true,
      layout: "horizontal",
      align: "left",
      verticalAlign: "top",
      itemDistance: 30,
      itemStyle: {
        fontFamily: '"inter", sans-serif',
        fontSize: "14px",
        fontWeight: '500',
        color: "#000000",
        whiteSpace: "nowrap",
      },
    },
    tooltip: {
      shared: true,
      crosshairs: true,
    },
    series: hasFilteredData
      ? filteredSeries.map(item => ({
          name: getShortLabel(item.label),
          data: item.data,
          color: getColorByLabel(item.label),
          marker: { enabled: false },
          connectNulls: true
        }))
      : placeholderSeries,
    credits: { enabled: false },
  };

  return (
    <div style={{ position: "relative" }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        key={JSON.stringify(filteredSeries)}
      />
      {(!hasData || !hasFilteredData) && (
        <div className="no-data-overlay">
          <h6>NO DATA <br />AVAILABLE</h6>
          <span style={{top:'65%'}}>Data unavailable ! Please wait for systems to get updated with activity data</span>
        </div>
      )}
    </div>
  );
};

export default PerformanceLineChart;
